import { localesToAddZeroFirstToMonth } from '../constants';
import { DateLocale } from '../enums';
const getMonth = (monthDate, locale) => {
  if (localesToAddZeroFirstToMonth.includes(locale)) {
    if (locale === 'vi') {
      const _monthDate$split = monthDate.split(' '),
        date = _monthDate$split[1];
      return '0' + date;
    } else {
      return '0' + monthDate;
    }
  } else {
    return monthDate;
  }
};
const getDay = (dayDate, t, prefix) => {
  const day = parseInt(dayDate, 10);
  if (day === 1 || day === 21 || day === 31) {
    return t(`${prefix}.utils.day_st_suffix`, {
      day
    });
  } else if (day === 2 || day === 22) {
    return t(`${prefix}.utils.day_nd_suffix`, {
      day
    });
  } else if (day === 3 || day === 23) {
    return t(`${prefix}.utils.day_rd_suffix`, {
      day
    });
  } else {
    return t(`${prefix}.utils.day_th_suffix`, {
      day
    });
  }
};
export const getLocaleDates = function (dateLocale, dateToConvert, monthFormat, dateFormat) {
  if (monthFormat === void 0) {
    monthFormat = 'short';
  }
  if (dateFormat === void 0) {
    dateFormat = 'numeric';
  }
  const date = new Date(dateToConvert);
  return {
    month: date.toLocaleString(dateLocale, {
      month: monthFormat
    }),
    day: date.toLocaleString(dateLocale, {
      day: dateFormat
    }),
    year: date.toLocaleString(dateLocale, {
      year: 'numeric'
    })
  };
};
export const getDateFromMsWithLocale = function (locale, dateToConvert, withYear, monthFormat, dateFormat, t, prefix) {
  if (withYear === void 0) {
    withYear = true;
  }
  if (monthFormat === void 0) {
    monthFormat = 'short';
  }
  if (dateFormat === void 0) {
    dateFormat = 'numeric';
  }
  const dateLocale = DateLocale[locale];
  const _getLocaleDates = getLocaleDates(dateLocale, Number(dateToConvert), monthFormat, dateFormat),
    month = _getLocaleDates.month,
    day = _getLocaleDates.day,
    year = _getLocaleDates.year;
  return {
    day: t && prefix ? getDay(day, t, prefix) : day,
    month: getMonth(month, locale),
    year: withYear ? year : undefined
  };
};
//# sourceMappingURL=getDateFromMsWithLocale.js.map